module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "light",
      "variant": "faded",
      "toggle-breakpoint": "md"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Hello'
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Editions")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'Copies'
      }
    }
  }, [_vm._v("Copies")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": "Admin",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'AdminIllustrations'
      }
    }
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'AdminCopies'
      }
    }
  }, [_vm._v("Copies")])], 1), _vm._v(" "), _c('b-nav-form', [_c('b-form-input', {
    staticClass: "mr-sm-2",
    attrs: {
      "size": "sm",
      "type": "text",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "my-2 my-sm-0",
    attrs: {
      "size": "sm",
      "type": "submit"
    }
  }, [_vm._v("Search")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b37355a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = 243
// module chunks = 1